import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {GlobalQuestionService} from '../../../services/global-question.service';

@Component({
    selector: 'app-vaps-general-eleven',
    templateUrl: './vaps-general-eleven.component.html',
    styleUrls: ['./vaps-general-eleven.component.scss'],
    standalone: false
})
export class VapsGeneralElevenComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: any;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAnother = false;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAnotherChanged = new EventEmitter<boolean>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();
  maskOptions: NgxCurrencyConfig;
  vaps = [];

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAnother?.currentValue === true) {
      this.addItem();
      this.addAnotherChanged.emit(false);
    }
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.vaps = [];
      this.getProductDetails();
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  getProductDetails(): any {
    if (this.getVapPrice(this.currentVap)) {
      for (const v of this.collation_vaps) {
        const item = {
          description1: [],
          description2: '',
          session_item_id: '1',
          price: 0,
          benefit_value: 0,
          option_id: 0,
          name: '',
          surname: '',
          show: true,
        };
        if (this.currentVap?.product_vaps_id === v?.product_vaps_id && v?.select === 1) {
          item.description1 = v?.detail.substring(0, v.detail.indexOf('|')).split('_');
          item.description2 = v?.detail.substring(v?.detail.indexOf('|') + 1, v?.detail?.length);
          item.session_item_id = v?.session_item_id ? v?.session_item_id : '1';
          item.price = v?.premium ? v?.premium : 0;
          item.benefit_value = v?.benefit_value ? v?.benefit_value : 0;
          item.option_id = v?.option_id;
          item.name = item?.description1?.length ? item?.description1[0] : '';
          item.surname = item?.description1?.length ? item?.description1[1] : '';
          item.show = false;

          this.vaps.push(item);
        }
      }
    } else {
      this.addItem();
    }
  }

  addItem(): void {
    let item_id = 1;
    if (this.vaps?.length) {
      item_id = this.vaps?.length + 1;
    }
    const item = {
      description1: [],
      description2: '',
      session_item_id: item_id.toString(),
      price: 0,
      benefit_value: 0,
      option_id: 0,
      name: '',
      surname: '',
      show: true,
    };
    this.vaps.push(item);
  }

  calculate(): void {
    for (let i = 0; i < this.vaps?.length; i++) {
      this.onChange(i, 1);
    }
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  onChange(index: number, action: number): void {
    if (this.vaps[index]?.name && this.vaps[index]?.surname && this.vaps[index]?.option_id && this.vaps[index]?.benefit_value) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vaps[index]?.name + '|' + this.vaps[index]?.surname + '|' + this.vaps[index]?.option_id + '|' + this.vaps[index]?.benefit_value.toString();
      this.question.answer = answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vaps[index]?.session_item_id, answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vaps[index]?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  p?.forEach(item => {
                    if (this.vaps[index].session_item_id === item?.session_item_id) {
                      this.vaps[index].price = item?.premium;
                    }
                  });
                  this.amountChanged.emit(this.vaps);
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.vaps[index].price = 0;
      this.amountChanged.emit(this.vaps);
    }
  }
}
